//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { RuleParameterModel } from './RuleParameterModel';
  
  export class RuleListModel extends ModelBase {
      static readonly $typeName = 'RuleListModel';
      public collectionDisplayName: string;
      public collectionName: string;
      public entityDisplayName: string;
      public entityName: string;
      public isEnabled: boolean;
      public moduleDisplayName: string;
      public moduleName: string;
      public ruleDisplayName: string;
      public ruleName: string;
      public ruleParameters: RuleParameterModel[];
      public messageNumber: string;
      public messageType: string;
      public message: string;
      public propertyName: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/RuleListModel.ts